import { QualifiedFeatureFragment } from "fe-common/graphql";
import { featureToLines } from "fe-common/logic";

// When to hide the left navigation panel (maximal size visable)
export const NavigationPanelBreakPoint = "lg";
// When to show each section in it's own page (maximal size)
export const SingleViewPerLayoutBreakPoint = "md";
export const MobileView = "xs";

export const MAX_SCREEN_WIDTH = 1681;

export function stringToColor(str: string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < str.length; i += 1) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.substr(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

export const getQFFragementDisplayName = (
  feature: QualifiedFeatureFragment,
): string => {
  if (!feature) {
    return "";
  }
  return featureToLines(feature)[0];
};
